import {isDevMode, NgModule} from '@angular/core';
import {RouteReuseStrategy, RouterModule, Routes} from '@angular/router';
import {MobileMenuComponent} from './mobile-menu/mobile-menu.component';
import {MainComponent} from './main/main.component';
import {HomepageComponent} from './homepage/homepage.component';
import {WorksComponent} from './works/works.component';
import {ProjectsComponent} from './projects/projects.component';
import {AproposComponent} from './apropos/apropos.component';
import {PageNotFoundComponent} from './page-not-found/page-not-found.component';
import {CustomReuseStrategy} from './custom-reuse-strategy';


const appRoutes: Routes = [

  {
    path: 'mobilemenu',
    component: MobileMenuComponent
  },
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: '',
        component: HomepageComponent
      },
      {
        path: 'project/:project',
        component: ProjectsComponent,
        data: {animation: 'ProjectPage'}
      },
      {
        path: 'works',
        component: WorksComponent,
        data: {animation: 'WorksPage'}
      },
      {
        path: 'apropos',
        component: AproposComponent
      },
      {
        path: '**',
        component: PageNotFoundComponent
      }

    ]
  },
  {
    path: '**',
    component: PageNotFoundComponent
  }

];

// configures NgModule imports and exports
@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      scrollPositionRestoration: 'top'
    })],
  providers: [{
    provide: RouteReuseStrategy,
    useClass: CustomReuseStrategy
  }],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
